module.exports = __webpack_public_path__ + "img/lyzt_c.c4a90363.png";